import React from "react";
import "./Brand.css";
import Marquee from "react-fast-marquee";

const brands = [
  "/assets/ups-logo.svg",
  "/assets/g-african-industries-logo.svg",
  "/assets/gsk-logo.svg",
  "/assets/axxela-logo.svg",
  "/assets/the-place-logo.svg",
  "/assets/ets-logo.svg",
  "/assets/credpal-logo.svg",
  "/assets/fibre-one-90.svg",
  "/assets/sahara-icon.svg",
  "/assets/page-logo.svg",
  "/assets/credit pro logo.png",
  "/assets/spectranet logo.png",
  "/assets/omniretail logo.png",
  "/assets/uba logo.png",
];

const Brand = () => {
  return (
    <div className="brand">
      <h3>They Trust Us</h3>
      <p className="sub-head">and so can you</p>

      <Marquee>
        {brands.map((brand, index) => {
          return (
            <div className="brand-image" key={index}>
              <img src={brand} alt={brand} />
            </div>
          );
        })}
      </Marquee>
    </div>
  );
};

export default Brand;
